import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';

import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";

@Injectable({
  providedIn: 'root'
})
export class ModificacionMarcionesService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }


  getAllEmployeesByDepartment(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAllEmployeesByDepartment + payload.department);
  }

  getAllEmployees() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAllEmployees);
  }

  getAllDepartment() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAllDepartment);
  }

  getAll(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAll + payload.id + '?fechaFin=' + payload.endDate + '&fechaInicio=' + payload.startDate);
  }

  guardarMarcacion(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.create, payload);
    //return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.update, payload);
  }

  actualizarMarcacion(payload) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.update + payload.id, payload);
    //return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.update, payload);
  }

  eliminarMarcacion(id: string) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.delete + id);
  }

  downloadReport(payload): Observable<string> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.report + 'fechaInicio=' + payload.startDate + '&fechaFin=' + payload.endDate);
  }

  downloadReportReplica(payload): Observable<string> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.reportReplica + 'fechaInicio=' + payload.startDate + '&fechaFin=' + payload.endDate);
  }

}
